import Cookies from 'js-cookie'
import Config from '@/settings'
import store from '@/store'
const TokenKey = Config.TokenKey

const IdTokenKey = Config.IdTokenKey

const AccessTokenKey = Config.AccessTokenKey

const casSessionKey = Config.CASSESSION

const linkTokenKey = Config.LinkTokenKey

export function getIdToken() {
  return Cookies.get(IdTokenKey)
}

export function getToken() {
  return Cookies.get(TokenKey)
}


export function getKey(key) {
  return Cookies.get(key)
}


export function setToken(token) {

  console.log("getRolesId")
  //判断
  store.dispatch('user/getRolesId').then(response => {
    console.log(response)
    if(response!=null){
      let roleids =response.roleids
      let user_id= response.id
      console.log(user_id)
      if(user_id!=1){
        if(roleids==null || roleids==''){
          return  window.location.href= '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
        }else{
          let arr = roleids.split(",");
          if (!arr.includes('171')) {
            console.log("1111")
            return  window.location.href= '/#/preview/bfbf9d74-f5f2-11ed-b281-db66c29b9542'
          }
        }
      }
    }
  })
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(casSessionKey)
  Cookies.remove(IdTokenKey)
  Cookies.remove(AccessTokenKey)
  return Cookies.remove(TokenKey)
}

export function getLinkToken() {
  return Cookies.get(linkTokenKey)
}

export function setLinkToken(token) {
  return Cookies.set(linkTokenKey, token)
}

export function removeLinkToken() {
  return Cookies.remove(linkTokenKey)
}

export function setSysUI(uiInfo) {
  return Cookies.set('sysUiInfo', uiInfo ? JSON.stringify(uiInfo) : null)
}

export function getSysUI() {
  const json = Cookies.get('sysUiInfo')
  return json ? JSON.parse(json) : store.getters.uiInfo
}

export function getTimeOut() {
  const val = Cookies.get('request-time-out')
  return val
}

